var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaugh1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laugh",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10005",
    "data-name": "Path 10005",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8Zm8.065,15.323a3.226,3.226,0,1,1-3.226,3.226A3.226,3.226,0,0,1,33.065,23.323Zm-16.129,0a3.226,3.226,0,1,1-3.226,3.226A3.226,3.226,0,0,1,16.935,23.323ZM40.212,38.04a14.528,14.528,0,0,1-14.405,12.7H24.194A14.528,14.528,0,0,1,9.788,38.04a1.619,1.619,0,0,1,1.411-1.8,1.512,1.512,0,0,1,.192-.012H38.609a1.613,1.613,0,0,1,1.613,1.613A1.678,1.678,0,0,1,40.212,38.04Z",
    fill: "#36ab80",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10006",
    "data-name": "Path 10006",
    d: "M155.355,160a3.226,3.226,0,1,0,3.226,3.226A3.226,3.226,0,0,0,155.355,160Zm-16.129,0a3.226,3.226,0,1,0,3.226,3.226A3.226,3.226,0,0,0,139.226,160Z",
    transform: "translate(-122.29 -136.677)",
    fill: "#36ab80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaugh1);
export default __webpack_public_path__ + "static/media/laugh-1.d99e107e67a990e1061845d9208a8abe.svg";
export { ForwardRef as ReactComponent };